import { useEffect } from "react";

const LowStockSocket = ({ socket, userRole, setAlertInfo }) => {
    useEffect(() => {
        if (!userRole?.scopeId) return;

        // Listen for low stock alerts
        socket.on("lowStockAlert", (data) => {
            if (Array.isArray(data.notify) && data.notify.length > 0) {
                const message = (
                    <div>
                        {data.notify.map((item, index) => (
                            <div key={index}>
                                {item.message}
                            </div>
                        ))}
                    </div>
                );
                setAlertInfo({ message, variant: "danger" });
                console.log(message);
            }
        });

        // Cleanup listener when scopeId changes or unmount
        return () => {
            socket.off("lowStockAlert");
        };
    }, [userRole?.scopeId, socket, setAlertInfo]);

    return null; // this component doesn't render UI
};

export default LowStockSocket;
